<template></template>

<script>
import axios from "axios";

export default {
    name: "SearchEngine",
    props: {
        value: String,
        limit: Number
    },
    data() {
        return {
            debounce: null
        }
    },
    watch: {
        value: function(val) {
            this.search(val);
        }
    },
    methods: {
        search: function (q) {
            const params = {
                limit: this.limit || 20,
                q,
                include: 'image'
            }
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                axios.get(`/searching`, {params}).then(response => {
                    this.$emit('response', response.data)
                });
            }, 500);
        },

    }
}
</script>
